import { isObject } from 'util';
export function patch(target, overrides) {
    for (var _i = 0, _a = Object.entries(overrides); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        if (isObject(value)) {
            patch(target[key], overrides[key]);
        }
        else {
            target[key] = overrides[key];
        }
    }
}
//# sourceMappingURL=patch.js.map